import { __ } from "../../locales/translation";
import { formatPriceToAR } from "../../utils/utils";

export default function BuySellValuesTable({
    precioCompra = 0,
    precioVenta = 0,
    cantidadCompra = 0,
    cantidadVenta = 0,
}) {
    return (
        <div className="cot-buy-sell-values-table">
            <table>
                <thead>
                    <tr>
                        <th className="medium-text"> </th>
                        <th className="medium-text">{__("Cantidad")}</th>
                        <th className="medium-text">{__("Precio")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="medium-text index">{__("Compra")}</td>
                        <td className="medium-text">{cantidadCompra}</td>
                        <td className="medium-text">{formatPriceToAR(precioCompra)}</td>
                    </tr>
                    <tr>
                        <td className="medium-text index">{__("Venta")}</td>
                        <td className="medium-text">{cantidadVenta}</td>
                        <td className="medium-text">{formatPriceToAR(precioVenta)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
